var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWorld = function SvgWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.103,
    height: 32,
    viewBox: "0 0 32.103 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web-site",
    transform: "translate(-1.887 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    "data-name": "Trazado 102",
    d: "M17.936,34a16,16,0,0,1-.1-32h.1a16,16,0,1,1,.1,32ZM17.844,2.914a15.113,15.113,0,1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    "data-name": "Trazado 103",
    d: "M17.936,34a16,16,0,0,1-.1-32h.1a16,16,0,1,1,.1,32ZM17.844,2.914a15.113,15.113,0,1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    "data-name": "Trazado 104",
    d: "M27.845,34C23.5,34,20.055,27.005,20,18.049,19.943,9.077,23.313,2.028,27.67,2H27.7c4.346,0,7.79,6.994,7.846,15.951C35.6,26.923,32.228,33.972,27.871,34Zm-.17-31.085c-3.717.023-6.811,6.952-6.762,15.128s3.225,15.043,6.933,15.043h.019c3.717-.023,6.811-6.952,6.762-15.128S31.4,2.914,27.695,2.914Z",
    transform: "translate(-9.832 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    "data-name": "Trazado 105",
    d: "M36.439,34a.457.457,0,0,1-.457-.454L35.787,2.46A.457.457,0,0,1,36.241,2h0a.457.457,0,0,1,.457.454L36.9,33.54a.457.457,0,0,1-.454.46Z",
    transform: "translate(-18.403 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106",
    "data-name": "Trazado 106",
    d: "M2.456,36.9a.457.457,0,0,1,0-.914l31.085-.2h0a.457.457,0,0,1,0,.914l-31.085.2Z",
    transform: "translate(-0.06 -18.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107",
    "data-name": "Trazado 107",
    d: "M7.494,18.9a.457.457,0,0,1,0-.914l26.377-.165h0a.457.457,0,0,1,0,.914L7.5,18.9Z",
    transform: "translate(-2.794 -8.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    "data-name": "Trazado 108",
    d: "M7.72,54.9a.457.457,0,0,1,0-.914l26.377-.165h0a.457.457,0,1,1,0,.914L7.722,54.9Z",
    transform: "translate(-2.917 -28.131)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world.00a220b4.svg";
export { ForwardRef as ReactComponent };